import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import InfoTooltip from '../InfoTooltip';
import {
  createCategory,
  createCleaner,
  createDoorList,
  createRepairMan,
  createSpecialAccesss,
  getBnbList,
  uploadFile,
} from '../../helper/backend_helper';

const AddRepairMan = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ profileImage: null });
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [bnb, setBnB] = useState([]);
  const [email, setEmail] = useState('');

  const [loading, setLoading] = useState(false);
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [users, setUsers] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      setUsers(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.BnBShortName?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.BnBShortName?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      if (!name) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Name is required',
        });
        setLoading(false);
        return;
      }

      if (!email) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Email is required',
        });
        setLoading(false);
        return;
      }

      if (!phoneNumber) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'phone no is required',
        });
        setLoading(false);
        return;
      }

      if (bnb.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'BnB Name is required',
        });
        setLoading(false);
        return;
      }

      // Prepare headers for multipart form data

      const Categorydata = {
        name,
        bnb,
        phoneNumber,
        email,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createRepairMan(Categorydata, Categoryheaders);

      Swal.fire({
        icon: 'success',
        title: 'Repairman created successfully',
      });
      setName('');
      setBnB([]);
      setPhoneNumber('');
      setEmail('');

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  const allBnBNames = useMemo(() => users.map((u) => u?.BnBShortName).filter(Boolean), [users]);
  const SELECT_ALL_VALUE = '__select_all__';

  return (
    <>
      <Helmet>
        <title> Add repairman </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Add Repair Man</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: '50ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Name <InfoTooltip title="The repairman's full name, used to identify them on maintenance assignments." /></FormLabel>
              <TextField
                label="Enter Name"
                id="outlined-size-small"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack mt={1} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Phone Number <InfoTooltip title="Contact number where the repairman is reached about maintenance jobs. Include the country code, e.g. +39…" /></FormLabel>
              <TextField
                type="text"
                label="Enter Phone Number"
                id="outlined-size-small"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack mt={1} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Email <InfoTooltip title="Email address used to notify the repairman of new maintenance requests." /></FormLabel>
              <TextField
                type="text"
                label="Enter Email"
                id="outlined-size-small"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack mt={1} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            {/* <FormControl sx={{ width: 490 }}>
              <FormLabel sx={{ mb: 1 }}>BnB</FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                multiple
                value={bnb} // This will be an array
                onChange={(e) => setBnB(e.target.value)}
                renderValue={(selected) => selected.join(', ')} // Render selected values as a comma-separated string
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    <Checkbox checked={bnb.indexOf(user.BnBShortName) > -1} />
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
            <FormControl sx={{ width: 490 }}>
              <FormLabel sx={{ mb: 1 }}>BnB <InfoTooltip title="The properties this repairman covers — maintenance requests from these BnBs are routed to them." /></FormLabel>
              <Select
                multiple
                value={bnb}
                onChange={(event) => {
                  const value = event.target.value;
                  if (value.includes(SELECT_ALL_VALUE)) {
                    // Toggle logic:
                    if (bnb.length === allBnBNames.length) {
                      setBnB([]); // all selected -> clear
                    } else {
                      setBnB(allBnBNames); // select all
                    }
                  } else {
                    // Normal selection (individual items)
                    setBnB(value);
                  }
                }}
                renderValue={(selected) => selected.join(', ')}
              >
                <MenuItem value={SELECT_ALL_VALUE}>
                  <Checkbox
                    checked={bnb.length === allBnBNames.length && allBnBNames.length > 0}
                    indeterminate={bnb.length > 0 && bnb.length < allBnBNames.length}
                  />
                  <Typography fontWeight="bold" color="primary">
                    {bnb.length === allBnBNames.length ? 'Deselect All' : 'Select All'}
                  </Typography>
                </MenuItem>
                <Box sx={{ borderBottom: '1px solid #e0e0e0', mx: 1, my: 0.5 }} />
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    <Checkbox checked={bnb.indexOf(user.BnBShortName) > -1} />
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>
    </>
  );
};

export default AddRepairMan;
